module.exports = __webpack_public_path__ + "img/flag_ph.562f203.png";